import React from "react";
import { Link } from "react-router-dom";
import useSEO from "../seo/useSEO";

function NotFoundPage() {
  useSEO({
    title: "Sayfa Bulunamadı | Aypin Otomat",
    description: "Aradığınız sayfa bulunamadı.",
    path: window.location.pathname,
    robots: "noindex, follow",
  });

  return (
    <main>
      <section
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "60px 20px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "90px",
              fontWeight: "700",
              color: "#0000ff",
              lineHeight: "1",
            }}
          >
            404
          </div>

          <h1 style={{ marginTop: "20px" }}>
            Sayfa Bulunamadı
          </h1>

          <p
            style={{
              color: "#666",
              fontSize: "16px",
              marginTop: "15px",
              marginBottom: "30px",
            }}
          >
            Aradığınız sayfa kaldırılmış, taşınmış veya adresi
            değiştirilmiş olabilir.
          </p>

          <Link
            to="/"
            style={{
              display: "inline-block",
              background: "#0000ff",
              color: "#fff",
              padding: "12px 28px",
              borderRadius: "4px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Ana Sayfaya Dön
          </Link>
        </div>
      </section>
    </main>
  );
}

export default NotFoundPage;